import React from "react";
import { Grid } from "@material-ui/core";
import { useQuery } from '@apollo/react-hooks';
import TileDefault from "../../Tiles/Default/TileDefault";
import TileList from "../../Tiles/List/TileList";
import { GET_ADUNITS } from "../../../queries/indicators";
import PageError from '../../PageError';
import PageLoading from '../../PageLoading';
import { Typography } from "../../../components/Wrappers";

let adUnitIndicators = [];
let adUnitIndicatorsGeneral = [];


export default function CPMIndicator(props) {
  var { publisherId } = props;

  let { data: dataIndicatorsAdUnits, error: errorAdUnits, loading: loadingAdUnits } = useQuery(GET_ADUNITS, {
    variables: { publisherId: publisherId[0] },
  });
  
  if(dataIndicatorsAdUnits && dataIndicatorsAdUnits.adUnitIndicatorsByPublisherId)
  {
    const adUnits = dataIndicatorsAdUnits.adUnitIndicatorsByPublisherId;
    //bestAdUnits.sort((a,b) => (a.cpm > b.cpm) ? 1 : ((b.cpm > a.cpm) ? -1 : 0));

    //const worstAdUnits = dataIndicatorsAdUnits.adUnitIndicatorsByPublisherId;
    //worstAdUnits.sort((a,b) => (a.cpm < b.cpm) ? 1 : ((b.cpm < a.cpm) ? -1 : 0));

    adUnitIndicators = [
      { 
        product:"Worst AdUnits by CPM", 
        data: adUnits.sort((a,b) => (a.cpm < b.cpm) ? 1 : ((b.cpm < a.cpm) ? -1 : 0))
        .count(3)
        .map(row => ({ name: row.name, value: row.cpm })) 
        //[ { name:"mx_d_header", value:"0.16" },{ name:"mx_d_p", value:"0.16" }] 
      },
      { 
        product:"Best AdUnits by CPM", 
        data: adUnits.sort((a,b) => (a.cpm < b.cpm) ? 1 : ((b.cpm < a.cpm) ? -1 : 0))
        .count(3)
        .map(row => ({ name: row.name, value: row.cpm })) 
        //[ { name:"mx_m_anchor", value:"0.27" },{ name:"mx_d_anchor", value:"0.26" }] 
      },
      { 
        product:"Worst AdUnits by Viewability", 
        data: adUnits.sort((a,b) => (a.viewability < b.viewability) ? 1 : ((b.viewability < a.viewability) ? -1 : 0))
        .count(3)
        .map(row => ({ name: row.name, value: row.viewability })) 
      },
      { 
        product:"Best AdUnits by Viewability", 
        data: adUnits.sort((a,b) => (a.viewability < b.viewability) ? 1 : ((b.viewability < a.viewability) ? -1 : 0))
        .count(3)
        .map(row => ({ name: row.name, value: row.viewability })) 
      }
    ];

    adUnitIndicatorsGeneral = [
      {
        product: "Worst AdUnits by CPM",
        today: { value: "mx_d_header" },
        week : [],
        yesterday: { value: "mx_d_header" },
        weekly: { value: "mx_d_header" },
        monthly: { value:  "mx_d_header" },
        color: "primary"
      },
      {
        product: "Best AdUnits by CPM",
        today: { value: "mx_m_anchor" },
        week : [],
        yesterday: { value: "mx_m_anchor" },
        weekly: { value: "mx_m_anchor" },
        monthly: { value:  "mx_m_anchor" },
        color: "primary"
      }
    ];
  }
  
  return (
    <>
      <Typography variant="h2">Ad Units</Typography>
      <br/>
      <Grid container spacing={4}>
      {
        (loadingAdUnits) ? <PageLoading /> : 
        (errorAdUnits) ? <PageError /> :
        (
          <>
          <Grid container spacing={4}>
            {
              adUnitIndicatorsGeneral.map(stat => (
                  <Grid item md={4} sm={6} xs={12} key={stat.product}>
                    <TileDefault {...stat} />
                  </Grid>
              ))
            }
          </Grid>
          <br/>
          <Grid container spacing={4}>
            {
              adUnitIndicators.map(stat => (
                  <Grid item md={4} sm={6} xs={12} key={stat.product}>
                    <TileList {...stat} />
                  </Grid>
              ))
            }
          </Grid>
          </>
        )
    }
    </Grid>
    </> 
  );
}